/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AWS from 'aws-sdk';
import { FormattedMessage } from 'react-intl';
import moment from 'utils/moment';
import styles from './form.module.scss';
import Auth from '../../../../utils/Auth';
import Loading from '../../../../components/loading';
import permitIcon from '../../../../icons/PERMITMODULE.png';
import Button from '../../../../components/button/button';
import { GetFileName, S3Uploads } from '../../../services';
import HeaderBack from '../../../../components/headerBack';
import SectionHeader from '../../../../components/sectionHeader';
import { changeCurrentPage } from '../../../../general_redux/actions';
import {
  clearState,
  ADP_Re_Apply,
  fetchspecificAdpLogs,
  getAdpCategories,
  clearDetailsState
} from '../../redux/action';
import {
  getValue,
  valueType,
  getCusAns,
  getDefAnswer,
  adpDefaultIDs,
  renderFieldComponent,
  handleSignature,
  getAttachmentIds
} from '../../components/PermitData';
import { getThreeLetterCountryCode } from '../../../../utils/helpers';

const ReApply = (props) => {
  const { match: { params: { id, installationId, airportCode } }, history } = props;

  const dispatch = useDispatch();
  const userProfile = useSelector(data => data?.auth?.profile);
  const userData = useSelector(data => data.permitManagement?.specificLog);
  const countryCode = useSelector(data => data?.auth?.profile?.portal_airport?.country_code);
  const defaultFields = useSelector(data => data?.permitManagement?.adpDSchema);
  const customFields = useSelector(data => data?.permitManagement?.adpCSchema);
  const ordering = useSelector(data => data?.permitManagement?.adpOrder);
  const adpCategories = useSelector(state => state?.permitManagement?.adpCategories);
  const submitStatus = useSelector(data => data?.permitManagement?.adp_Reapply_Status);
  const fetchStatus = useSelector(data => data.permitManagement?.loader);
  const notes = useSelector(data => data?.permitManagement?.specificLog?.schema?.default_fields?.notes);
  const reqAttach = useSelector(data => data?.permitManagement?.specificLog?.schema?.default_fields?.required_attachements);

  const [load, setLoad] = useState(false);
  const [state, setState] = useState({
    loader: false,
    preAnswers: {},
    answers: {},
    formErrors: false,
    dateError: false
  });
  const [errors, setErrors] = useState({});
  const [reqErrors, setReqErrors] = useState({});
  const [allFields, setAllFields] = useState([]);
  const [countryState, setCountryState] = useState([]);
  const [mergedFields, setMergedFields] = useState([]);
  const [conditionalFields, setConditionalFields] = useState({});
  const [initial, setInitial] = useState({ render1: false });

  const isIssuingAuthorityDisabled = defaultFields
    ?.some(field => field.id === 'issusing_authority' && field.isDisabled);

  useEffect(() => {
    setState({ ...state, loader: true });
    dispatch(fetchspecificAdpLogs(id));
    dispatch(getAdpCategories(true));
    dispatch(changeCurrentPage(userProfile?.permit_management?.driver_permit || 'ADP'));
  }, [dispatch, id]);

  useEffect(() => {
    if (defaultFields?.length > 0) {
      const default_fields = defaultFields.map((ele) => {
        const updatedField = { ...ele, disable: false };
        if (['first_name', 'last_name', 'phone'].includes(ele.id)) {
          updatedField.title = ele.title.includes("Applicant's") ? ele.title : `Applicant's ${ele.title}`;
          updatedField.type = ele.id === 'phone' ? 'telephone' : 'string';
          updatedField.required = true;
        } else if (ele.id === 'email') {
          updatedField.title = ele.title.includes("Applicant's") ? ele.title : `Applicant's ${ele.title}`;
        } else if (ele.id !== 'designation') {
          return ele;
        }
        return updatedField;
      });
      const combinedFields = [...default_fields, ...customFields];
      let Fields;
      let condFields = {};
      let fieldErros = { ...errors };
      const filteredFields = combinedFields?.filter(field => field?.id !== 'signature' && !field?.isDisabled);
      if (ordering?.length) { // sorted - if ordering
        Fields = ordering
          .map(orderId => filteredFields.find(field => field.id === orderId))
          .filter(field => field); // Remove undefined entries if any
      } else {
        Fields = filteredFields; // without sorted - if no ordering
      }
      setMergedFields(Fields);
      Fields.forEach((ele) => {
        if (ele.conditional) { // check the conditional fields
          if (condFields[ele.conditional_field.key]) {
            condFields[ele?.conditional_field?.key] = [...condFields[ele?.conditional_field?.key], ele];
          } else {
            condFields[ele?.conditional_field?.key] = [ele];
          }
        } else {
            fieldErros = { ...fieldErros, [ele.id]: ele.required };
        }
      });
      setConditionalFields(condFields);
      setErrors(fieldErros);
    } else {
      dispatch(fetchspecificAdpLogs(id));
      setState({ ...state, loader: true });
    }
    if (state.loader === true && fetchStatus === false) {
      setState({ ...state, loader: false });
    }
  }, [defaultFields]);

  useEffect(() => { // we should not send prev_permit key to backend
    if (userData && Object.keys(userData)?.length > 0 && !Object.keys(state.preAnswers || {})?.length > 0) {
      const userDataFilterPrevPermit={};
      Object.keys(userData).forEach((key) => {
      if ((key !== 'prev_permit') && (key !== 'initiated_to')) {
        userDataFilterPrevPermit[key]=userData[key];
      }
    });
      setState(prev => ({ ...prev,
        preAnswers: { ...prev.preAnswers, ...userDataFilterPrevPermit } }));
    }
  }, [userData, state.preAnswers]);

  useEffect(() => {
    let reqFieldError = {};
    if (reqAttach?.length > 0) {
      reqAttach.forEach((e) => {
        let name = e;
        if (typeof e === 'object') {
          name = e.attachmentName;
        }
        reqFieldError = {
          ...reqFieldError,
          [`${name}_attachments`]: (!state.answers?.req_attachments?.[`${name}_attachments`]?.length > 0)
        };
      });
      setReqErrors(reqFieldError);
    }
  }, [state.answers?.req_attachments, reqAttach]);

  // set the country states to issuing_authority field
  useEffect(() => {
  const mapStateToKeyValue = stateList => stateList?.map(each => ({
      key: each?.state,
      value: each?.state
    }));
  const updateIssuingAuthorityField = (ele, countryStates) => {
    if (ele.id === 'issusing_authority') {
      return {
        ...ele,
        values: mapStateToKeyValue(countryStates),
        default_value: {}
      };
    }
    return ele;
  };
  const setIssuingAuthorityValues = () => {
    const updatedFields = mergedFields?.map(ele => updateIssuingAuthorityField(ele, countryState));
    setAllFields(updatedFields);
    setInitial(prev => ({ ...prev, render1: true }));
  };
  if (!isIssuingAuthorityDisabled) {
    if (mergedFields?.length > 0 && countryState?.length > 0) {
      setIssuingAuthorityValues();
    }
  } else {
    setAllFields(mergedFields);
    setInitial(prev => ({ ...prev, render1: true }));
  }
}, [mergedFields, countryState, isIssuingAuthorityDisabled]);

useEffect(() => {
    if (initial.render1 && Object.keys(state.preAnswers)?.length > 0) {
      ['schema', 'additional_info',
       'work_flow', 'training', 'comment', 'id', 'settings', 'lms', 'meta_data', 'key']
        .forEach(e => delete state.preAnswers[e]);
      const all_attachments = userData?.attachments?.reduce((acc, obj) => ({ ...acc, [obj.attachment_id]: obj }), {});
      const requireAttachments = userData?.req_attachments
        && Object.keys(userData?.req_attachments)
        .reduce((acc, key) => ({ ...acc, [key]: userData?.req_attachments[key].map(att => all_attachments[att]) }), {});
      const sign = userData?.signature;
      const isEmptySignature = (Array.isArray(sign) && sign.length === 0)
        || (Array.isArray(sign) && sign.length === 1 && Object.keys(sign[0]).length === 0);
      setState(prev => ({ ...prev,
        answers: {
          ...state.preAnswers,
          ...state.answers,
          signature: isEmptySignature ? null : userData?.signature,
          req_attachments: requireAttachments
        }
      }));
      setInitial(prev => ({ ...prev, render1: false, renderForAttachments: true }));
    }
  }, [state.preAnswers, initial.render1, state.answers]);

    useEffect(() => {
      if (userData?.status === 14 && initial.renderForAttachments && Object.keys(state.preAnswers)?.length > 0) {
        const all_attachments = userData?.attachments?.reduce((acc, obj) => ({ ...acc, [obj.attachment_id]: obj }), {});
        const requireAttachments = userData?.req_attachments
          && Object.keys(userData?.req_attachments)
          .reduce((acc, key) => ({ ...acc, [key]: userData?.req_attachments[key].map(att => all_attachments[att]) }), {});
        const sign = userData.signature;
        const isEmptySignature = (Array.isArray(sign) && sign.length === 0)
          || (Array.isArray(sign) && sign.length === 1 && Object.keys(sign[0]).length === 0);
        setState(prev => ({ ...prev,
          answers: {
            ...prev.preAnswers,
            ...prev.answers,
            req_attachments: { ...requireAttachments },
            photo: userData?.photo,
            signature: isEmptySignature ? null : userData?.signature,
            attachments: userData?.attachments
          } }));
        setInitial(prev => ({ ...prev, renderForAttachments: false, render2: true }));
      }
    }, [state.preAnswers, initial.renderForAttachments, userData]);

  // country code api calling
  useEffect(() => {
    if (defaultFields?.length) {
      const getConfig = () => {
        const key = `cognito-idp.${process.env.REACT_APP_REGION}.amazonaws.com/${process.env.REACT_APP_USER_POOL_ID}`;
        AWS.config.update({
          region: process.env.REACT_APP_REGION,
          credentials: new AWS.CognitoIdentityCredentials({
            IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
            Logins: {
              [key]: Auth.getInstance().getIDToken()
            }
          })
        });
        return AWS.config.credentials.getPromise();
      };
      getConfig();

      const docClient = new AWS.DynamoDB.DocumentClient({ region: process.env.REACT_APP_REGION });
      const threeCharCode = getThreeLetterCountryCode(countryCode);
      const param = {
        TableName: 'aeros_countries_states',
        KeyConditionExpression: 'country_large_code = :country_large_code',
        ExpressionAttributeValues: {
          ':country_large_code': threeCharCode
        }
      };
      docClient.query(param).promise().then((res) => {
        setCountryState(res.Items);
      });
    }
  }, [defaultFields, countryCode]);

  useEffect(() => {
    if (allFields?.length > 0 && Object.keys(state.answers)?.length > 0 && initial.render2) {
      allFields.forEach((fieldId) => {
        const fieldValue = adpDefaultIDs.includes(fieldId)
          ? state.answers[fieldId]
          : state.answers?.response?.[fieldId];
        conditionalRendering(fieldId?.id, fieldValue);
      });
      setInitial(prev => ({ ...prev, render2: false }));
    }
  }, [allFields, state, adpDefaultIDs, conditionalFields, initial]);

    // Memoize newFieldErrors calculation outside of useEffect
  const newFieldErrors = useMemo(() => allFields
    .filter(fd => !fd.conditional && fd.type !== 'header' && fd.required)
    .reduce((acc, ele) => {
      let hasError;
      if (adpDefaultIDs.includes(ele.id)) {
        hasError = !state.answers[ele.id];
      } else if (ele.type === 'attachments') {
        hasError = !state.answers?.response?.[ele.id]?.length > 0;
      } else {
        hasError = !state.answers?.response?.[ele.id];
      }
    return {
      ...acc,
      [ele.id]: hasError
    };
  }, {}), [state.answers, allFields]);

  useEffect(() => {
    setErrors((prevErrors) => {
      const hasChanges = Object.keys(newFieldErrors).some(
        key => newFieldErrors[key] !== prevErrors[key]
      );
      return hasChanges ? { ...prevErrors, ...newFieldErrors } : prevErrors;
    });
  }, [newFieldErrors]); // Note: Only depend on `newFieldErrors`

  // clear the state after submitting
  useEffect(() => {
    if (submitStatus?.loading === false && (submitStatus.success === true)) {
      dispatch(clearState());
      history.push('/adp/logs');
    }
    if (submitStatus.error === true) setState({ ...state, loader: false });
  }, [submitStatus, history, dispatch]);

  useEffect(() => () => {
    dispatch(clearDetailsState());
  }, [dispatch]);

  const conditionalRendering = (fieldId, answer) => {
    if (conditionalFields?.[fieldId]) { // check the conditional fields
      conditionalFields[fieldId].forEach((item) => {
        const conditionValues = item?.conditional_values;
        const fieldValue = answer;
        const enableCondition = conditionValues.some(value => fieldValue === value?.value);
        const defaultValue = valueType(item)?.value;
        if (item.required) {
          handleFieldErrorChanged(
            item.id,
            enableCondition ? getValue(item, state?.answers) : false
          );
        }
        if (enableCondition) {
          setState(prev => ({
            ...prev,
            answers: {
              ...prev.answers,
              ...(adpDefaultIDs.includes(item.id)
                ? { [item.id]: getDefAnswer(item, state?.answers) }
                : { response: { ...prev.answers.response, [item.id]: getCusAns(item, state?.answers) } }
              )
            }
          }));
        } else {
          setState(prev => ({
            ...prev,
            answers: {
              ...prev.answers,
              ...(adpDefaultIDs.includes(item.id)
                ? { [item.id]: defaultValue }
                : { response: { ...prev.answers.response, [item.id]: defaultValue } }
              )
            }
          }));
        }
      });
    }
  };

  const handleAnswerChanged = (section, answer, fieldId) => {
    conditionalRendering(fieldId, answer);
    if (section === 'response') { // check custom field answers
      setState(prevState => ({
        ...prevState,
        answers: {
          ...prevState.answers,
          response: {
            ...prevState.answers.response,
            [fieldId]: answer
          }
        }
      }));
    } else if (section === 'req_attachments') { // check required attachment answers
      setState(prevState => ({
        ...prevState,
        answers: {
          ...prevState.answers,
          req_attachments: {
            ...prevState.answers.req_attachments,
            [fieldId]: answer
          }
        }
      }));
    } else if (section === 'req_attachments_dates') {
      setState(prevState => ({
        ...prevState,
        answers: {
          ...prevState.answers,
          req_attachments_details: {
            ...prevState.answers.req_attachments_details,
            [section]: {
              ...prevState.answers.req_attachments_details?.[section],
              [fieldId]: answer
            }
          }
        }
      }));
    } else { // check default field answers
      setState(prevState => ({
        ...prevState,
        [section]: {
          ...prevState[section],
          [fieldId]: answer
        }
      }));
    }
  };

  const handleFieldErrorChanged = (fieldId, value) => {
    setErrors(prevErrors => ({ ...prevErrors, [fieldId]: value }));
  };

  const handleRemoveAttachments = (attachment) => {
    const filtereAttachments = state.answers?.attachments?.filter(e => e?.attachment_id !== attachment?.attachment_id);
    setState(prev => ({ ...prev, answers: { ...prev.answers, attachments: filtereAttachments } }));
  };

  // ----------- Attachment Upload function start -----------
  const handleUploadAttachments = async (attachments, entity) => {
    const attachmentIds = [];
    const newAttachments = [];
    const oldAttachments = [];
    attachments.forEach((e) => {
      if (!e.id) {
        newAttachments.push(e);
      } else if (e.id && e.name) {
        oldAttachments.push(e.name);
      }
    });
    let fileIds = '';
    if (newAttachments.length > 0) {
      fileIds = await getFileNames(newAttachments?.length);
    }
    if (fileIds) {
      await doS3Upload(
        newAttachments,
        fileIds,
        entity || 'driver_permit'
      ).then(() => {
        fileIds.filename.forEach((i) => {
          attachmentIds.push(i.toString());
        });
      });
    }
    if (oldAttachments.length > 0) {
      attachmentIds.push(...oldAttachments);
    }
    return attachmentIds;
  };

  const uploadtoS3 = async (attachments) => {
    let fileIds = '';
    fileIds = await getFileNames(attachments.length);
    const list = [];
    if (fileIds) {
      await doS3Upload(attachments, fileIds, 'driver_permit')
        .then((res) => {
          res.forEach((ele) => {
            list.push(ele?.id?.toString());
          });
        });
    }
    return list;
  };

  const getFileNames = async (count) => {
    const response = await GetFileName.getUploadFileName(count);
    return response;
  };

  const doS3Upload = async (files, fileIds, entity) => {
    const response = await S3Uploads.uploadFiles(
      files,
      fileIds.filename,
      entity,
      installationId,
      airportCode
    );
    return response;
  };

  // ----------- Attachment Upload functions end -----------

  const handelSubmit = async (isDraft = false) => {
    const { lic_exp_date, lic_issue_date, dob } = state.answers;

    // Validate inputs
    const error = validateInputs(state.answers, errors, reqAttach);
    const noErrors = Object.values(error).every(value => value === false);
    const noReqErrors = Object.values(reqErrors).every(value => value === false);

    const dateError = validateDates({ dob, lic_issue_date, lic_exp_date });
    if (dateError) {
      setState(prev => ({ ...prev, dateError }));
      return;
    }
    if (!isDraft && noErrors && noReqErrors) {
        await submitApplicationData();
    } else if (isDraft) {
        await submitApplicationData(isDraft);
    } else {
        setState(prev => ({ ...prev, formErrors: true, dateError: false }));
    }
  };

  const validateInputs = (answers, errorList, reqAttachs) => ({
    ...errorList,
    attachments: !reqAttachs?.length > 0 ? !answers.attachments?.length : false,
    signature: !answers.signature,
    photo: !answers?.photo?.length > 0
  });

  const validateDates = ({ dob, lic_issue_date, lic_exp_date }) => {
    const currentDate = moment().startOf('day');
    const issueDate = lic_issue_date ? moment(lic_issue_date) : null;
    const expireDate = lic_exp_date ? moment(lic_exp_date) : null;
    const dateOfBirth = dob ? moment(dob) : null;

    if (issueDate?.isAfter(currentDate)) {
      return 'License Issue Date cannot be a future date. Please modify the date and try again.';
    }
    if (expireDate?.isBefore(currentDate)) {
      return 'License Expire Date should be a future date. Please modify the date and try again.';
    }
    if (issueDate && expireDate && issueDate.isAfter(expireDate)) {
      return 'License Issued date should not be older than License Expiry date.';
    }
    if (dateOfBirth && currentDate.diff(dateOfBirth, 'year') < 17) {
      return 'Applicant age should be 17 years or above.';
    }
    return null;
  };

  const submitApplicationData = async (isDraftApp = false) => {
    const {
      attachments,
      signature,
      photo,
      req_attachments
    } = state.answers;
    setState({
        ...state,
        loader: true,
        dateError: ''
    });

    const attchList = reqAttach?.length > 0 && Object.entries(req_attachments || {}).reduce((acc, [key, attachment]) => {
      if (Array.isArray(attachment)) {
        acc[key] = attachment
          .map(item => item?.attachment_id)
          .filter(aid => typeof aid === 'string');
      } else {
        acc[key] = [];
      }
      return acc;
    }, {});
    const attachmentId = (!reqAttach?.length > 0 && attachments?.length > 0)
      ? attachments.map(item => item?.attachment_id).filter(aid => typeof aid === 'string')
      : [];
    const photoId = (photo?.length > 0 && Array.isArray(photo))
      ? photo.map(item => item?.attachment_id).filter(pid => typeof pid === 'string')
      : [];
    const signatureId = await handleSignature(signature, handleUploadAttachments, uploadtoS3, 'driver_permit');

    await uploadCustomAttachments();

    await uploadCustomSignature();

    const dataObject = payloadDataObject({
        attchList,
        attachmentId,
        photoId,
        signatureId,
        isDraftApp
    });
    finalSubmit(dataObject);
  };

  const uploadCustomAttachments = async () => {
    const attachmentFields = customFields.filter(
        schemaField => schemaField?.type === 'attachments'
    );
    const uploadingAttachments = attachmentFields.map(async (schemaField) => {
      const attachmentField = schemaField?.id;
      if (schemaField?.type === 'attachments' && state.answers?.response?.[attachmentField]?.length > 0) {
        state.answers.response[attachmentField] = state.answers.response[attachmentField]
          .map(item => item?.attachment_id)
          .filter(aid => typeof aid === 'string');
      }
    });
    await Promise.all(uploadingAttachments);
  };

  const uploadCustomSignature = async () => {
    const signatureFields = customFields.filter(schemaField => schemaField?.type === 'signature');

    const uploadingSignature = signatureFields?.map(async (schemaField) => {
      const signatureField = schemaField?.id;
      const value = state.answers?.response?.[signatureField]
          ? [state.answers.response[signatureField]]
          : [];

      const signatureValue = Array.isArray(state.answers?.response?.[signatureField])
        ? state.answers.response[signatureField]
        : value;

      if (signatureValue.length > 0) {
        state.answers.response[signatureField] = (await handleUploadAttachments(signatureValue, 'driver_permit')) || [];
      }
    });

    await Promise.all(uploadingSignature);
  };

  const payloadDataObject = ({ attchList, attachmentId, photoId, signatureId, isDraftApp }) => {
    const { answers } = state;
    const adp_category_id = adpCategories?.find(ele => ele.name === state.answers?.category_of_adp);
    return {
      ...answers,
      order_number: id,
      photo: photoId,
      admin_response: answers.admin_response ? getAttachmentIds(answers.admin_response) : {},
      attachments: attachmentId,
      req_attachments: attchList,
      signature: signatureId?.[0] || [],
      adp_category: adp_category_id?.id || null,
      status: isDraftApp ? 'Draft' : null,
      dob: answers.dob
        ? moment(answers.dob).format('YYYY-MM-DD')
        : answers.dob,
      lic_exp_date: answers.lic_exp_date
        ? moment(answers.lic_exp_date).format('YYYY-MM-DD')
        : answers.lic_exp_date,
      lic_issue_date: answers.lic_issue_date
        ? moment(answers.lic_issue_date).format('YYYY-MM-DD')
        : answers.lic_issue_date
    };
  };

  const finalSubmit = (dataObject) => {
    let data = { ...dataObject };
    if (data.photo?.length) {
        data.attachments.push(...data.photo);
    }
    if (reqAttach?.length > 0 && Object.keys(data.req_attachments)?.length > 0) {
        data.attachments.push(...Object.values(data.req_attachments).flat());
    }
    const checkboxFields = allFields.filter(field => field.type === 'boolean');
    checkboxFields.forEach((field) => {
      if (!data.response[field.id]) {
        data.response[field.id] = false;
      }
    });

    if (userData.initiated_to) {
      data.initiated_to= userData?.initiated_to?.id;
    }

    dispatch(ADP_Re_Apply(id, data));
  };

  const getLoadingStatus = value => setLoad(value);

  // Helper function to get answers
  const getAnswers = fieldId => (
    adpDefaultIDs.includes(fieldId)
    ? state.answers[fieldId]
    : state.answers.response?.[fieldId]);

  // Build the answers object using a loop
  const fieldAnswers = {};
  allFields.forEach((field) => {
    fieldAnswers[field.id] = getAnswers(field.id);
  });

  return (
    <>
      <SectionHeader
        icon={permitIcon}
        translationID=" "
        defaultTitle={userProfile.permit_management?.driver_permit || 'Airside Driving Permit'}
      />
      <HeaderBack
        translationID="workorder.settings.back"
        translationDefault="Back"
        backRoute={`/adp/detail/${id}`}
        exactRoute
      />
      <div className={styles.container}>
        <Loading loadingStatus={state.loader || !allFields?.length > 0} />
        <div className={styles.headder}>
          <FormattedMessage
            id=" "
            defaultMessage={`Re Open ${userProfile?.permit_management?.driver_permit || 'ADP'}`}
          />
        </div>
        <div className={styles.childContainer}>
          {
            renderFieldComponent(
              state,
              notes,
              errors,
              reqAttach,
              allFields,
              fieldAnswers,
              handleAnswerChanged,
              handleRemoveAttachments,
              handleFieldErrorChanged,
              handleUploadAttachments,
              getLoadingStatus,
              'driver_permit'
            )
          }
        </div>
        <div className={styles.submitButton}>
          <p className={styles.errorMessage}>
            {state.dateError}
            {(!state.dateError && state.formErrors) && (
              <>
              * Please fill all the required fields
              </>
            )}
          </p>
          <div style={{ display: 'flex', gap: '16px' }}>
            <Button
              action="tertiary"
              onClick={() => history.push(`/adp/detail/${id}`)}
              translationID="inspections.new.cancelBtn"
              defaultText="Cancel"
            />
            <Button
              action="primary"
              onClick={() => handelSubmit(true)}
              translationID="inspections.complete_inspections.save_as_draft"
              defaultText="Save as Draft"
              disabled={load}
            />
            <Button
              action="secondary"
              onClick={() => (handelSubmit(false))}
              translationID="adp.submit"
              defaultText="Update"
              disabled={load}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ReApply;
